import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppNotificationUtilClass, Engineeri8DataService } from '@monorepo/services';
import { catchError, exhaustMap, finalize, from, map, of, switchMap, take } from 'rxjs';
import {
  FetchCommonMasterListingSuccess,
  FetchCommonMasterListingFailure,
  FetchFatigueAllowanceList,
  FetchFatigueAllowanceListSuccess,
  FetchFatigueAllowanceListFailure,
  FetchBundleAllowanceSuccess,
  FetchBundleAllowanceFailure,
  FetchCommonMasterListing,
} from './masters.action';
import { MastersActionType } from './masters.models';

@Injectable({ providedIn: 'root' })
export class MastersEffects {
  constructor(
    private actions$: Actions,
    private engineeri8DataService: Engineeri8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchMasterListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MastersActionType.FetchCommonMasterListing),
      exhaustMap((action: FetchCommonMasterListing) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) => {
            switch (action.master) {
              case 'PRODUCT_TYPE':
                return this.engineeri8DataService.searchProductTypeMaster(action.payload).pipe(
                  finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
                  map((res) => new FetchCommonMasterListingSuccess({ type: 'PRODUCT_TYPE', res })),
                  catchError(() => of(new FetchCommonMasterListingFailure())),
                );
              case 'OPERATION':
                return this.engineeri8DataService.searchOperationMaster(action.payload).pipe(
                  finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
                  map((res) => new FetchCommonMasterListingSuccess({ type: 'OPERATION', res })),
                  catchError(() => of(new FetchCommonMasterListingFailure())),
                );
              case 'PART':
                return this.engineeri8DataService.searchPartMaster(action.payload).pipe(
                  finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
                  map((res) => new FetchCommonMasterListingSuccess({ type: 'PART', res })),
                  catchError(() => of(new FetchCommonMasterListingFailure())),
                );
              case 'MACHINE':
                return this.engineeri8DataService.searchMachineMaster(action.payload).pipe(
                  finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
                  map((res) => new FetchCommonMasterListingSuccess({ type: 'MACHINE', res })),
                  catchError(() => of(new FetchCommonMasterListingFailure())),
                );
              case 'STYLE_NO':
                return this.engineeri8DataService.searchStyleMaster(action.payload).pipe(
                  finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
                  map((res) => new FetchCommonMasterListingSuccess({ type: 'STYLE_NO', res })),
                  catchError(() => of(new FetchCommonMasterListingFailure())),
                );
            }
          }),
        ),
      ),
    ),
  );

  fetchFatigueAllowanceList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MastersActionType.FetchFatigueAllowanceList),
      exhaustMap((action: FetchFatigueAllowanceList) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.engineeri8DataService.searchFatigueAllowanceMaster(action.searchRequest).pipe(
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
              map((res) => new FetchFatigueAllowanceListSuccess(res)),
              catchError(() => of(new FetchFatigueAllowanceListFailure())),
            ),
          ),
        ),
      ),
    ),
  );

  fetchBundleAllowance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MastersActionType.FetchBundleAllowance),
      exhaustMap(() =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.engineeri8DataService.getBundleAllowance().pipe(
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
              map((res) => new FetchBundleAllowanceSuccess(res)),
              catchError(() => of(new FetchBundleAllowanceFailure())),
            ),
          ),
        ),
      ),
    ),
  );
}
